import axios from '../../api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getJMCTemplateList = createAsyncThunk('JMCtemplateList', async () => {
  const response = await axios.get(
    `/switch/templates/jmc`,
  );
  return response.data;
});
